module.exports = __webpack_public_path__ + "img/shouye_jifen@2x.f93991cd.png";